import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import ReactTable from "react-table";
import * as config from '../Configuration/Config.js'
import UserProfile from '../Configuration/UserProfile.js'

class AdminUsersGrid extends Component {

    constructor() {

        super();

        this.handleNewUser = this.handleNewUser.bind(this)
        this.handleBack = this.handleBack.bind(this)

        this.state = {
            redirect_new_user: false,
            redirect_back: false,
            is_loaded: false,
            customer_id: null,
            users: null
        }
    }

    setRedirectBack() {
        this.setState({redirect_back: true});
    }

    componentDidMount() {

        // get customer list
        var that = this;

        var customer_id = this.props.match.params.cid;

        const uri = config.getUriPath('users/' + customer_id + '/search')

        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            return response.json();
          })
          .then(function(data) {

            that.setState({ users: data, is_loaded: true, customer_id: customer_id });
          });
    }

    handleNewUser(event) {
        event.preventDefault();

        this.setState({redirect_new_user: true});
    }

    handleBack(event) {
        event.preventDefault();

        this.setRedirectBack();        
    }

    render() {

        if (this.state.is_loaded === false) {
            return <div></div>
        }

        if (this.state.redirect_new_user) {
            return <Redirect to={"/admin/users/" + this.state.customer_id + "/profile/new"} />
        }

        const profile = new UserProfile();
        const isAcumenAdmin = profile.IsAcumenAdmin();

        if (isAcumenAdmin && this.state.redirect_back){
            return <Redirect to='/admin/customers' />
        }

        const {users, customer_id} = this.state;
        const title = customer_id === config.AcumenAdminName ? "System Administrators" : "Users";
        const newButtonText = customer_id === config.AcumenAdminName ? "Add New System Administrator" : "Add User";
        if (users === null || users === undefined|| users.length === 0) {

            return <div className="grid-wrapper">
                        <div className="center-div">
                            <h1>{title}</h1>
                        </div>

                        <div className="ReactTableCenter">
                            <div className="addNewButton">
                                <button className="btn btn-primary" onClick={this.handleNewUser}>{newButtonText}</button>
                                &nbsp;&nbsp;
                                <button className={isAcumenAdmin ? "btn btn-primary" : "hidden"} onClick={this.handleBack}>Back to Customer</button>
                            </div>
                        </div>
                    <br/>
                    <h1>No Users Found</h1>                
            </div>
        }

        return <div className="grid-wrapper">
                <div className="center-div">
                    <h1>{title}</h1>
                </div>
                <div className="ReactTableCenter">
                    <div className="addNewButton">
                        <button className="btn btn-primary" onClick={this.handleNewUser}>{newButtonText}</button>
                        &nbsp;&nbsp;
                        <button className={isAcumenAdmin ? "btn btn-primary" : "hidden"} onClick={this.handleBack}>Back to Customer</button>
                   </div>
                </div>
                <div className="ReactTableCenter">
                    <ReactTable
                        data={users}
                        minRows="0"
//                      defaultPageSize="5"
                        columns={[
                            {
                                accessor: "user_id",
                                width: 100,
                                resizable: false,
                                style: { textAlign: "center"},
                                Header: "",
                                Cell: row=>(
                                    <div className="gridButton">
                                        <a href={'/admin/users/' + customer_id + '/profile/'  + row.value} className="btn btn-success cwedit" role="button">EDIT</a>                                        
                                    </div>
                                )
                            },
                            {
                                Header: "First Name",
                                accessor: "given_name",
                                Cell: row=>(
                                    <div className="gridValue">
                                        {row.value}
                                    </div>
                                )
                            },
                            {
                                Header: "Last Name",
                                accessor: "family_name",
                                Cell: row=>(
                                    <div className="gridValue">
                                        {row.value}
                                    </div>
                                )
                            },
                            {
                                Header: "Email",
                                accessor: "email_address",
                                Cell: row=>(
                                    <div className="gridValue">
                                        {row.value}
                                    </div>
                                )
                            },
                            {
                                Header: "Role",
                                accessor: "security_role",
                                Cell: row=>(
                                    <div className="gridValue">
                                        {config.SecurityRoles.getRow(row.value)}
                                    </div>
                                )
                            }
                        ]}

                        defaultPageSize={users.length}
                        showPagination={false}
                        className="-striped -highlight" >
                    </ReactTable>
                    <br></br>
                    <br></br>
                    <br></br>
                </div>
        </div>
    }
}



export default AdminUsersGrid


// WEBPACK FOOTER //
// ./src/Components/AdminUsers/AdminUsersGrid.js